import React from 'react'
import PropTypes from 'prop-types'

import RoundIcon from '../../../../shared/settings/round-icon'
import styles from '../payment.css'

import closeIcon from '../../../../../../images/closeModal.svg'

const RemoveIcon = ({ onClick, isDefault }) => {
  return (
    <div>
      {
        isDefault
          ? (
            <div
              className={`${styles.removeButton} ${styles.removeButtonDisabled}`}
            >
              <p>
                Can`t remove
                <br />
                {' '}
                a default
                <br />
                {' '}
                card
              </p>
            </div>
          )
          : (
            <div
              className={styles.removeButton}
              onClick={!isDefault && onClick}
            >
              <RoundIcon alt="Close Icon" src={closeIcon} disabled={isDefault} />
            </div>
          )
      }
    </div>
  )
}

RemoveIcon.propTypes = {
  onClick: PropTypes.func,
  isDefault: PropTypes.bool
}

RemoveIcon.defaultProps = {
  onClick: () => {},
  isDefault: false
}

export default RemoveIcon
